(() => {
  'use strict';
  if (customElements.get('pb-case-model-switcher')) return;

  function collectionURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || !/(?:^|\/)collections\/[^/]+\/?$/.test(url.pathname)) return null;
      url.search = '';
      url.hash = '';
      return url;
    } catch (_) { return null; }
  }

  // Bundled brand icons; Apple path from Simple Icons (CC0).
  const brandMarks = {"apple":{"viewBox":"0 0 24 24","path":"M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"}};
  function brandContent(container, label) {
    container.replaceChildren();
    const key = label.trim().toLowerCase();
    if (!['apple','samsung','google'].includes(key)) { container.textContent = label; return false; }
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', key === 'google' ? '0 0 18 18' : '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'pbcs-brand-mark pbcs-brand-mark--' + key);
    const add = (name, attrs) => {
      const node = document.createElementNS(ns, name);
      for (const [attr,value] of Object.entries(attrs)) node.setAttribute(attr, value);
      svg.append(node);
      return node;
    };
    if (key === 'apple') add('path', {d:brandMarks.apple.path});
    if (key === 'samsung') {
      add('rect', {x:'0',y:'0',width:'24',height:'24',rx:'8',fill:'#078bff'});
      add('path', {fill:'#fff',d:'M16.7 7.1c-1.1-1.4-2.6-2.1-4.6-2.1-3.1 0-5.1 1.7-5.1 4.1 0 2.2 1.7 3.3 4.4 3.9l1.4.3c1.3.3 1.8.7 1.8 1.4 0 .9-.9 1.4-2.4 1.4-1.6 0-2.7-.6-3.5-1.7l-2.3 1.8c1.3 1.9 3.3 2.8 5.9 2.8 3.4 0 5.5-1.7 5.5-4.4 0-2.2-1.4-3.4-4.3-4.1l-1.5-.3c-1.3-.3-1.9-.7-1.9-1.3 0-.8.8-1.2 2.1-1.2 1.3 0 2.2.5 2.9 1.3z'});
    }
    if (key === 'google') {
      add('path', {fill:'#4285F4',d:'M17.64 9.2045c0-.638-.0573-1.2518-.1636-1.8409H9v3.4818h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2582h2.9091c1.7023-1.5673 2.6832-3.8755 2.6832-6.6155z'});
      add('path', {fill:'#34A853',d:'M9 18c2.43 0 4.4673-.8059 5.9568-2.18l-2.9091-2.2582c-.8059.54-1.8368.8591-3.0477.8591-2.3441 0-4.3282-1.5832-5.0359-3.7105H.9568v2.3318C2.4382 15.9832 5.4818 18 9 18z'});
      add('path', {fill:'#FBBC05',d:'M3.9641 10.7105C3.7841 10.1705 3.6818 9.5932 3.6818 9s.1023-1.1705.2823-1.7105V4.957H.9568C.3477 6.1718 0 7.5468 0 9s.3477 2.8282.9568 4.0432l3.0073-2.3318z'});
      add('path', {fill:'#EA4335',d:'M9 3.5795c1.3214 0 2.5086.4541 3.4418 1.3459l2.5827-2.5827C13.4632.8918 11.4259 0 9 0 5.4818 0 2.4382 2.0168.9568 4.9568l3.0073 2.3318C4.6718 5.1614 6.6559 3.5795 9 3.5795z'});
    }
    const text = document.createElement('span');
    text.className = 'pbcs-brand-name';
    text.textContent = label;
    container.append(svg, text);
    return true;
  }

  let dropdownId = 0;

  class StyledDropdown {
    constructor(select, label, options, onOpen) {
      this.select = select;
      this.label = label;
      this.onOpen = onOpen;
      this.active = -1;
      this.search = '';
      this.lastTyped = 0;
      let root = select.closest('.pbcs-dropdown');
      if (!root) {
        const field = select.closest('label');
        root = document.createElement('div');
        root.className = 'pbcs-dropdown';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = field.className + ' pbcs-switcher-trigger';
        button.setAttribute('role', 'combobox');
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        const icon = field.querySelector('svg:not(.pbcs-switcher-chevron)');
        if (icon) button.append(icon.cloneNode(true));
        const text = document.createElement('span');
        const caption = document.createElement('span');
        caption.className = 'pbcs-switcher-label';
        caption.textContent = label;
        const value = document.createElement('span');
        value.className = 'pbcs-switcher-value';
        text.append(caption, value);
        button.append(text);
        const arrow = field.querySelector('.pbcs-switcher-chevron');
        if (arrow) button.append(arrow.cloneNode(true));
        const list = document.createElement('div');
        list.className = 'pbcs-dropdown-panel';
        list.id = 'pbcs-dropdown-' + (++dropdownId);
        list.setAttribute('role', 'listbox');
        list.setAttribute('aria-label', label + ' options');
        list.hidden = true;
        button.setAttribute('aria-controls', list.id);
        field.replaceWith(root);
        root.append(select, button, list);
        select.hidden = true;
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');
      }
      this.root = root;
      this.button = root.querySelector('.pbcs-switcher-trigger');
      this.list = root.querySelector('.pbcs-dropdown-panel');
      this.value = root.querySelector('.pbcs-switcher-value');
      this.refresh();

      this.button.addEventListener('click', () => this.isOpen ? this.close() : this.open(), options);
      this.button.addEventListener('keydown', event => this.keydown(event), options);
      this.list.addEventListener('pointerdown', event => {
        if (event.target.closest('[data-option-index]')) event.preventDefault();
      }, options);
      this.list.addEventListener('click', event => {
        const option = event.target.closest('[data-option-index]');
        if (option && this.list.contains(option)) this.choose(Number(option.dataset.optionIndex));
      }, options);
      this.list.addEventListener('pointermove', event => {
        const option = event.target.closest('[data-option-index]');
        if (option) this.highlight(Number(option.dataset.optionIndex), false);
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.root.contains(event.target)) this.close();
      }, options);
      root.addEventListener('focusout', event => {
        if (!root.contains(event.relatedTarget)) this.close();
      }, options);
      window.addEventListener('resize', () => this.close(), options);
      select.addEventListener('change', () => this.refresh(), options);
    }

    get isOpen() { return this.button.getAttribute('aria-expanded') === 'true'; }

    refresh() {
      this.close();
      this.button.disabled = this.select.disabled;
      const label = this.select.selectedOptions[0]?.textContent || this.select.options[0]?.textContent || 'Choose';
      this.value.textContent = label;
      if (this.label === 'Brand') {
        let slot = this.button.querySelector('.pbcs-brand-trigger-icon');
        if (!slot) {
          slot = document.createElement('span');
          slot.className = 'pbcs-brand-trigger-icon';
          slot.setAttribute('aria-hidden', 'true');
          const oldIcon = this.button.querySelector(':scope > svg:not(.pbcs-switcher-chevron)');
          if (oldIcon) oldIcon.replaceWith(slot); else this.button.prepend(slot);
        }
        const hasLogo = brandContent(slot, label);
        slot.querySelector('.pbcs-brand-name')?.remove();
        if (!hasLogo) slot.textContent = '';
        this.button.classList.add('pbcs-has-brand-logo');
      }
      this.button.setAttribute('aria-label', this.label + ': ' + label);
      this.list.replaceChildren();
      this.items = [];
      const groups = new Map();
      for (const option of this.select.options) {
        if (option.disabled || !option.value) continue;
        let parent = this.list;
        if (option.parentElement.tagName === 'OPTGROUP') {
          const heading = option.parentElement.label;
          if (!groups.has(heading)) {
            const group = document.createElement('div');
            group.setAttribute('role', 'group');
            group.setAttribute('aria-label', heading);
            const title = document.createElement('div');
            title.className = 'pbcs-dropdown-group';
            title.setAttribute('aria-hidden', 'true');
            title.textContent = heading;
            group.append(title);
            this.list.append(group);
            groups.set(heading, group);
          }
          parent = groups.get(heading);
        }
        const item = document.createElement('div');
        item.id = this.list.id + '-option-' + this.items.length;
        item.className = 'pbcs-dropdown-option';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', String(option.value === this.select.value));
        item.dataset.optionIndex = String(this.items.length);
        if (this.label === 'Brand') {
          brandContent(item, option.textContent);
          item.setAttribute('aria-label', option.textContent);
        } else item.textContent = option.textContent;
        parent.append(item);
        this.items.push({node:item, value:option.value, label:option.textContent});
      }
    }

    open(last = false) {
      if (this.button.disabled || !this.items.length) return;
      this.onOpen?.();
      const rect = this.button.getBoundingClientRect();
      const below = window.innerHeight - rect.bottom;
      const above = rect.top;
      const up = below < 180 && above > below;
      this.root.classList.toggle('opens-up', up);
      this.list.style.maxHeight = Math.min(360, Math.max(100, (up ? above : below) - 16)) + 'px';
      this.list.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      this.root.classList.add('is-open');
      const selected = this.items.findIndex(item => item.value === this.select.value);
      this.highlight(selected >= 0 ? selected : (last ? this.items.length - 1 : 0));
    }

    close() {
      this.list.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      this.button.removeAttribute('aria-activedescendant');
      this.root.classList.remove('is-open');
      this.search = '';
      this.active = -1;
    }

    highlight(index, scroll = true) {
      if (!this.items.length) return;
      this.active = (index + this.items.length) % this.items.length;
      for (const [i,item] of this.items.entries()) item.node.classList.toggle('is-active', i === this.active);
      this.button.setAttribute('aria-activedescendant', this.items[this.active].node.id);
      if (scroll) this.items[this.active].node.scrollIntoView?.({block:'nearest'});
    }

    choose(index) {
      const item = this.items[index];
      if (!item) return;
      this.select.value = item.value;
      this.close();
      this.button.focus({preventScroll:true});
      this.select.dispatchEvent(new Event('change', {bubbles:true}));
    }

    keydown(event) {
      if (event.key === 'Tab') { this.close(); return; }
      if (event.key === 'Escape') { if (this.isOpen) { event.preventDefault(); event.stopPropagation(); this.close(); } return; }
      if (['ArrowDown','ArrowUp','Home','End','Enter',' '].includes(event.key)) {
        event.preventDefault();
        if (!this.isOpen) {
          this.open(event.key === 'ArrowUp');
          if (event.key === 'Home') this.highlight(0);
          if (event.key === 'End') this.highlight(this.items.length - 1);
          return;
        }
        if (event.key === 'ArrowDown') this.highlight(this.active + 1);
        else if (event.key === 'ArrowUp') this.highlight(this.active - 1);
        else if (event.key === 'Home') this.highlight(0);
        else if (event.key === 'End') this.highlight(this.items.length - 1);
        else this.choose(this.active);
        return;
      }
      if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault();
        if (!this.isOpen) this.open();
        const now = Date.now();
        this.search = (now - this.lastTyped < 700 ? this.search : '') + event.key.toLowerCase();
        this.lastTyped = now;
        const query = [...this.search].every(c => c === this.search[0]) ? this.search[0] : this.search;
        for (let offset=1; offset<=this.items.length; offset++) {
          const index = (this.active + offset) % this.items.length;
          if (this.items[index].label.toLowerCase().startsWith(query)) { this.highlight(index); break; }
        }
      }
    }
  }

  class CaseModelSwitcher extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const brandSelect = this.querySelector('[data-brand-select]');
      const modelSelect = this.querySelector('[data-model-select]');
      const controls = this.querySelector('[data-controls]');
      const fallback = this.querySelector('[data-fallback]');
      if (!brandSelect || !modelSelect || !controls || !fallback) return;

      this.brands = new Map();
      this.current = null;
      let contextBrand = '';
      for (const link of fallback.querySelectorAll('a[data-case-model]')) {
        const url = collectionURL(link.getAttribute('href'));
        const brand = (link.dataset.brand || '').trim();
        const label = link.textContent.trim();
        if (!url || !brand || !label) continue;
        if (!this.brands.has(brand)) this.brands.set(brand, new Map());
        const models = this.brands.get(brand);
        if (!models.has(url.href)) models.set(url.href, {url:url.href, label, group:link.dataset.group || ''});
        if (link.dataset.current === 'true' && !this.current) this.current = {brand, url:url.href};
        if (link.dataset.brandCurrent === 'true' && !contextBrand) contextBrand = brand;
      }
      if (!this.brands.size) return;

      // Series pages may not be linked as parents in the navigation menu.
      // Keep exact menu context first, then recognise the collection family.
      if (!this.current && !contextBrand) {
        const label = (this.dataset.currentLabel || '').trim();
        const family = /\b(?:iphone|ipad|apple|macbook)\b/i.test(label) ? 'apple'
          : /\b(?:samsung|galaxy)\b/i.test(label) ? 'samsung'
          : /\b(?:google|pixel)\b/i.test(label) ? 'google' : '';
        const candidates = [...this.brands.keys()].filter(brand => brand.toLowerCase() === family);
        if (family && candidates.length === 1) contextBrand = candidates[0];
        else if (this.brands.size === 1) contextBrand = this.brands.keys().next().value;
      }

      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.brandSelect = brandSelect;
      this.modelSelect = modelSelect;
      brandSelect.replaceChildren(new Option('Choose brand', ''));
      for (const brand of this.brands.keys()) brandSelect.add(new Option(brand, brand));
      brandSelect.value = this.current?.brand || contextBrand;
      this.populateModels(brandSelect.value, true);
      brandSelect.disabled = false;
      this.brandDropdown = new StyledDropdown(brandSelect, 'Brand', options, () => this.modelDropdown?.close());
      this.modelDropdown = new StyledDropdown(modelSelect, 'Model', options, () => this.brandDropdown?.close());

      brandSelect.addEventListener('change', () => {
        this.populateModels(brandSelect.value, false);
        const status = this.querySelector('[data-status]');
        if (status) status.textContent = brandSelect.value ? `Choose your ${brandSelect.value} model.` : 'Choose a brand first.';
      }, options);
      modelSelect.addEventListener('change', () => {
        const models = this.brands.get(brandSelect.value);
        const selected = models?.get(modelSelect.value);
        if (!selected) return;
        const destination = collectionURL(selected.url);
        const current = collectionURL(location.href);
        if (!destination || (current && destination.pathname.replace(/\/$/, '') === current.pathname.replace(/\/$/, ''))) return;
        location.assign(destination.href);
      }, options);
      controls.hidden = false;
      fallback.hidden = true;
    }

    populateModels(brand, initial) {
      const select = this.modelSelect;
      const models = this.brands.get(brand);
      const currentMissing = initial && !this.current && !brand && this.dataset.currentLabel;
      const placeholder = new Option(currentMissing ? this.dataset.currentLabel : (brand ? 'Choose your model' : 'Choose brand first'), '');
      placeholder.disabled = true;
      select.replaceChildren(placeholder);
      const groups = new Map();
      for (const model of models?.values() || []) {
        let target = select;
        if (model.group) {
          if (!groups.has(model.group)) {
            const group = document.createElement('optgroup');
            group.label = model.group;
            select.append(group);
            groups.set(model.group, group);
          }
          target = groups.get(model.group);
        }
        target.append(new Option(model.label, model.url));
      }
      select.value = this.current?.brand === brand ? this.current.url : '';
      select.disabled = !models?.size;
      this.modelDropdown?.refresh();
    }

    disconnectedCallback() {
      this.brandDropdown?.close();
      this.modelDropdown?.close();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('pb-case-model-switcher', CaseModelSwitcher);
})();
